<template>
    <div class="col-md-8 mx-auto">
        <div v-if="has_price">
            <v-text-field
                    v-model="price"
                    label="قیمت"
                    required
                    prepend-inner-icon="fa fa-pencil-alt"
                    clear-icon="mdi-close-circle"
                    clearable
                    type="number"
                    color="indigo"
                    dense
                    outlined
            >
            </v-text-field>
        </div>
        <div class="title">
            <v-text-field
                    v-model="title"
                    :rules="titleRoules"
                    :counter="50"
                    label="عنوان آگهی"
                    hint="در عنوان آگهی به موارد مهم و چشمگیر اشاره کنید"
                    required
                    :append-icon="marker ? 'fa fa-edit' : 'fa fa-edit' "
                    :prepend-inner-icon="icon"
                    :append-outer-icon="titleChecker ? 'fa fa-check' : 'fa fa-times'"
                    clear-icon="mdi-close-circle"
                    clearable
                    type="text"
                    @click:prepend-inner="titlemojiShow=true"
                    @click:clear="clearMessage"
                    @click:append="toggleMarker"
                    @click:append-outer="checkTitle"
                    :error-messages="message"
                    id="titles"
                    color="indigo"
                    dense
                    outlined
                    :max="maxLetters"
                    name="title"
            >
            </v-text-field>
            <v-sheet v-if="titlemojiShow === true" class="mb-1" color="white lighten-3"
                     outlined
                     rounded>
                <v-card-text class="py-0 my-0" style="background-color: rgba(255,255,255,0.45)">
                    <button type="button" v-for="item in titleEmojies"
                            class="btn my-1  align-content-center py-1"
                            @click="emojiPickertitle"
                            :data-emoji="item">{{ item }}
                    </button>
                </v-card-text>
                <v-btn color="error" text @click="titlemojiShow = false"><i class="fa fa-times text-danger"></i></v-btn>
            </v-sheet>
        </div>
        <div class="desc">
            <v-textarea
                    v-model="description"
                    :rules="descRoules"
                    :counter="1000"
                    :error-messages="descError"
                    label="توضیحات آگهی"
                    required
                    rows="13"
                    hint="جزئیات و نکات قابل توجه آگهی خود را کامل و دقیق بنویسید. درج شماره موبایل در متن آگهی مجاز نیست ."
                    dense
                    outlined
                    :append-icon="marker ? 'fa fa-edit' : 'fa fa-edit' "
                    @click:append="toggleDefault"
                    :prepend-inner-icon="icon"
                    clear-icon="mdi-close-circle"
                    clearable
                    type="text"
                    @click:prepend-inner="mojiShow = true"
                    @click:clear="clearMessage"
                    id="titles"
                    name="description"
            ></v-textarea>
            <v-sheet v-if="mojiShow === true" class="mb-1" color="white lighten-3"
                     outlined
                     rounded>
                <v-card-text class="py-0 my-0" style="background-color: rgba(255,255,255,0.45)">
                    <button type="button" v-for="item in descEmojies"
                            class="btn my-1  align-content-center py-1"
                            @click="emojiPickerdesc"
                            :data-emoji="item">{{ item }}
                    </button>
                </v-card-text>
                <v-btn color="error" text @click="mojiShow = false"><i class="fa fa-times text-danger"></i></v-btn>
            </v-sheet>
        </div>
        <v-dialog
                v-model="defaultTitle"
                persistent
                max-width="500"
                class="px-5"
        >
            <v-card>
                <v-toolbar
                        flat
                        dark
                        color="primary"
                >

                    <v-toolbar-title> متن آماده</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn
                                icon
                                dark
                                @click="defaultTitle = false"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text class="pt-5">
                    <v-autocomplete label="متن پیشفرض" @input="setTitle" chips deletable-chips :items="texts"
                                    item-text="title"
                                    prepend-inner-icon="fa fa-pencil-alt"
                                    :id="texts.id">
                        <template v-slot:item="data">
                            <v-list-item-content>
                                <v-list-item-title>
                                    <span class="text-capitalize"> {{ index }} -  {{
                                            data.item.title
                                        }} - {{ data.item.category }}</span>
                                </v-list-item-title>
                            </v-list-item-content>
                        </template>
                    </v-autocomplete>
                    <v-autocomplete label="آگهی  پیشفرض" @input="setTitle" chips deletable-chips :items="Ads"
                                    item-text="title"
                                    :id="Ads.id"
                                    prepend-inner-icon="fa fa-pencil-alt"
                    >
                        <template v-slot:item="data">
                            <v-list-item-content>
                                <v-list-item-title>
                                    <span class="text-capitalize"> {{ index }} -  {{
                                            data.item.title
                                        }}</span>
                                </v-list-item-title>
                            </v-list-item-content>
                        </template>
                    </v-autocomplete>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="getText"
                persistent
                max-width="500"
                class="px-5"
        >
            <v-card>
                <v-toolbar
                        flat
                        dark
                        color="primary"
                >

                    <v-toolbar-title>
                        <div class="row">
                            <span class="text-right col-md"> متن و عنوان غیرتکراری</span>

                            <span v-if="expireTime !== '' "
                                  class="float-left col-md mr-11">زمان باقی مانده : {{ parseInt(expireTime / 60) + ":" + (expireTime % 60) }} </span>
                        </div>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn
                                icon
                                dark
                                @click="delOptions"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text class="pt-5">
                    <v-text-field :error-messages="productMessage" dense clearable v-model="jobKeyword"
                                  label="نام محصول / خدمات" outlined
                                  clear-icon="mdi-close-circle-outline"></v-text-field>
                    <v-btn v-if="productMessage === '' && jobKeyword !== '' " class="btn-dec-with-text ml-auto"
                           @click="getSuggest">
                        <span class="fa fa-save ml-1" style="font-size: 1.2rem"></span>
                        ثبت پیشنهادات
                    </v-btn>
                    <v-autocomplete label="عنوان پیشنهادی" @change="authecnticate" v-if="suggestTexts.titles != null"
                                    @input="setTitle" chips
                                    deletable-chips
                                    :items="suggestTexts.titles"
                                    prepend-inner-icon="fa fa-pencil-alt"
                    >
                    </v-autocomplete>
                    <v-autocomplete label="توضیحات پیشنهادی" v-if="suggestTexts.descriptions !== null" @input="setDesc"
                                    chips
                                    deletable-chips
                                    :items="suggestTexts.descriptions"
                                    prepend-inner-icon="fa fa-pencil-alt"
                    >
                    </v-autocomplete>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="defaultDesc"
                persistent
                max-width="500"
                class="px-5"
        >
            <v-card>
                <v-toolbar
                        flat
                        dark
                        color="primary"
                >

                    <v-toolbar-title> متن آماده</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn
                                icon
                                dark
                                @click="defaultDesc = false"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text class="pt-5">
                    <v-autocomplete label="متن پیشفرض" @input="setDesc" chips deletable-chips :items="texts"
                                    item-text="description"
                                    prepend-inner-icon="fa fa-pencil-alt"
                                    :id="texts.id">
                        <template v-slot:item="data">
                            <v-list-item-content>
                                <v-list-item-title>
                                    <span class="text-capitalize"> {{ index }} -  {{
                                            data.item.description
                                        }} - {{ data.item.category }}</span>
                                </v-list-item-title>
                            </v-list-item-content>
                        </template>
                    </v-autocomplete>
                    <v-autocomplete label="آگهی پیشفرض" @input="setDesc" chips deletable-chips :items="Ads"
                                    item-text="description"
                                    prepend-inner-icon="fa fa-pencil-alt"
                                    :id="Ads.id">
                        <template v-slot:item="data">
                            <v-list-item-content>
                                <v-list-item-title>
                                    <span class="text-capitalize"> {{ index }} -  {{
                                            data.item.description
                                        }}</span>
                                </v-list-item-title>
                            </v-list-item-content>
                        </template>
                    </v-autocomplete>
                </v-card-text>
            </v-card>
        </v-dialog>
        <automatics :key="$vnode.key" :time="true" :multi-ads="false" AutoSend="false"></automatics>
    </div>
</template>

<script>
import Automatics from "@/view/pages/ads/timeHandelers/automatics";
import {Bus} from "@/main";
import Swal from "sweetalert2";
import {Axios2} from "../../../main";

export default {
    name: "inputs",
    components: {Automatics},
    props: {
        has_price: {
            type: Boolean,
            default: false
        },
        category: {
            default: ''
        },
        city: {
            default: ''
        }
    },
    data() {
        return {
            valid: false,
            getText: false,
            jobKeyword: '',
            productMessage: '',
            titlemojiShow: false,
            defaultDesc: false,
            price: '',
            descError: '',
            mojiShow: false,
            title: '',
            titleChecker: true,
            titleRoules: [
                v => !!v || 'عنوان آگهی را وارد کنید.',
                v => v.length < 50 || 'عنوان آگهی نمیتواند بیش از 50 کاراکتر داشته باشد.',
                v => v.length > 3 || 'عنوان آگهی از نمیتواند کمتر از 3 کاراکتر داشته باشد.'
            ],
            descRoules: [
                D => !!D || 'توضیحات آگهی را وارد کنید.',
                D => D.length < 1000 || 'توضیحات آگهی نمیتواند بیش از 1000 کاراکتر داشته باشد.',
                D => D.length > 10 || 'توضیحات آگهی از نمیتواند کمتر از 10 کاراکتر داشته باشد.'
            ],
            show: false,
            message: '',
            expireTime: '',
            marker: true,
            iconIndex: 0,
            icons: [
                'mdi-emoticon',
                'mdi-emoticon-angry',
                'mdi-emoticon-excited',
            ],
            descEmojies: ["✌️", "✅", "♻️", "❎", "✳️", "❇️", "✔️", "☑️", "⚫", "⚪", "▪️", "▫️", "◾", "◽", "◼️", "◻️", "⬛", "⬜", "♾️", "✖️", "➗", "➖", "➕", "↩️", "↪️", "⤵️", "⤴️", "↔️", "↕️", "↖️", "↙️",
                "↘️", "↗️", "⬇️", "⬆️", "⬅️", "➡️", "◀️", "⏬", "⏫", "⏪", "⏩", "*️⃣", "#️⃣"],
            titleEmojies: ["%", "٪", "*", "×", "،", ".", "-", "+", "«", "»", "&", "'", "(", ")", "/"],
            emoji: false,
            defaultTitle: false,
            texts: [],
            Ads: [],
            suggestTexts: {
                titles: null,
                descriptions: null,
            },
            description: '',
            titleErorrs: '',
            neighborhood: '',
            maxLetters: 0,
            adsTimes: {
                available_at: '',
                expire_at: '',
            },
        }
    },
    methods: {
        validate() {
            let validate = true;

            if (this.title === '') {
                this.message = 'عنوان آگهی را پر کنید.'
                validate = false
            } else if (this.description === '') {
                this.descError = 'توضیحات آگهی را پر کنید.'
                validate = false
            }

            return validate;
        },
        delOptions() {
            this.getText = false;
            if (this.title != null || this.title !== '' || this.title !== undefined)
                this.suggestTexts.titles.splice(this.suggestTexts.titles.indexOf(this.title), 1);

            if (this.description != null || this.description !== '' || this.description !== undefined)
                this.suggestTexts.descriptions.splice(this.suggestTexts.descriptions.indexOf(this.description), 1);
        },
        toggleMarker() {
            this.marker = !this.marker
            this.defaultTitle = true
        },
        toggleDefault() {
            this.marker = !this.marker
            this.defaultDesc = true
        },
        clearMessage() {
            this.message = ''
        },
        resetIcon() {
            this.iconIndex = 0
        },
        changeIcon() {
            this.emoji = true
        },
        setTitle(e) {
            this.title = e;
            this.defaultTitle = false
        },
        setDesc(e) {
            this.description = e;
            this.defaultDesc = false
        },
        emojiPickerdesc(element) {
            const $title = $(element.target).parents(".desc").find('[name = "description"]')[0];

            let currentInput = $title.value;
            let cursorPos = $title.selectionStart;
            let textBefore = currentInput.substring(0, cursorPos);
            let textAfter = currentInput.substring(cursorPos, currentInput.length);

            $title.value = textBefore + $(element.target).data("emoji") + textAfter;
            this.description = $title.value;

            this.$nextTick(function () {
                $title.focus();
                $title.setSelectionRange(cursorPos, cursorPos);
            })
        },
        emojiPickertitle(element) {
            const $title = $(element.target).parents(".title").find('[name = "title"]')[0];

            let currentInput = $title.value;
            let cursorPos = $title.selectionStart;
            let textBefore = currentInput.substring(0, cursorPos);
            let textAfter = currentInput.substring(cursorPos, currentInput.length);

            $title.value = textBefore + $(element.target).data("emoji") + textAfter;
            this.title = $title.value;

            this.$nextTick(function () {
                $title.focus();
                $title.setSelectionRange(++cursorPos, cursorPos);
            })
        },
        checkTitle() {
                this.getText = true;
                this.getCookie('timer');
        },
        getTimes() {
            this.startTime = this.$refs.adsTime.times.starttime;
            this.endTime = this.$refs.adsTime.times.endtime;
        },
        getTitles() {
            $.ajax({
                url: `${url}/default/text/all`,
                method: "GET",
                fn: this.getTitles,
                headers: {
                    ACCEPT: 'application/json',
                    Authorization: Token,
                    "Content-Type": 'application/json'
                },
                success: (data) => {
                    this.texts = data
                }
            })
        },
        getTitlesAds() {
            $.ajax({
                url: `${url}/default/own/all`,
                method: "GET",
                fn: this.getTitles,
                headers: {
                    ACCEPT: 'application/json',
                    Authorization: Token,
                    "Content-Type": 'application/json'
                },
                success: (data) => {
                    this.Ads = data
                }
            })
        },
        authecnticate() {
            $.ajax({
                url: `${url}/divar/check/title`,
                type: "POST",
                fn: this.checkTitle,
                headers: {
                    ACCEPT: "application/json",
                    Authorization: Token,
                    "Content-type": 'application/json'
                },
                msg: false,
                data: JSON.stringify({
                    "title": this.title,
                    "city": String(this.city),
                    "category": this.category
                }),
                error: (data) => {
                    if (data.status === 422) {
                        this.$modal.error('خطا', 'لطفا اطلاعات فرم را کامل نمایید.')
                    } else {
                        this.$modal.error('خطا', 'عنوان مورد نظر قابل قبول نمی باشد.')
                    }
                },
                success: (data) => {
                    this.$nextTick(function () {
                        this.$modal.success(data.message)
                    })
                }
            });
        },
        getSuggest() {
            this.$modal.showLoading();
            if (this.expireTime === '') {
                Axios2.post('/shop/default', JSON.stringify({
                    "category": this.current,
                    "city": String(this.city),
                    "keyword": this.jobKeyword,
                    "length": 10
                })).then((response) => {
                    this.$modal.hideLoading();
                    if (response.data.data.length <= 0) {
                        this.$modal.error('خطا!', 'اطلاعات آگهی و یا نام محصول صحیح نیست.');
                    } else {
                        localStorage.removeItem('suggestions');
                        this.suggestTexts.titles = response.data.data.map(x => x.title);
                        this.suggestTexts.descriptions = response.data.data.map(x => x.description);
                        this.setCookies('timer', 'time', 10);
                        localStorage.setItem('suggestions', response.data.data);
                    }

                }).catch((error) => {
                    this.$modal.error('خطا!', 'لطفا اطلاعات فرم را تکمیل فرمایید!');
                })
            } else this.$modal.info('هشدار!', 'تاپایان زمان باقی مانده شما قادر به ایجاد درخواست جدید نیستید.')
        },
        setCookies(key, value, min) {
            const d = new Date();
            d.setTime(d.getTime() + (min * 60 * 1000));
            let expires = "expires=" + d.toUTCString();
            document.cookie = key + "=" + value + ";" + expires + ";path=/";
            document.cookie = key + "_expire=" + expires.replace("expires=", "");
        },
        getCookie(key) {
            let cookies = document.cookie.split(";")
            let now = new Date();

            let newCookies = cookies.filter((item) => item.indexOf("_expire") > -1).map((item) => {
                let expire_cookie = item.trim().split("=");
                let cookie = cookies.find(x => x.indexOf(expire_cookie[0].replace("_expire", "") + "=") > -1)?.trim()?.split("=") || [];
                let expire = new Date(expire_cookie[1]);
                this.expireTime = parseInt((expire.getTime() / 1000) - (now.getTime() / 1000));

                return {
                    name: expire_cookie[0].replace("_expire", ""),
                    value: cookie[1] || null,
                    expire_at: parseInt((expire.getTime() / 1000) - (now.getTime() / 1000))
                }
            });

            return newCookies.find((item) => item.name === key);
        }
    },
    computed: {
        icon() {
            return this.icons[this.iconIndex]
        }
    },
    watch: {
        expireTime(val) {
            if (val <= 0) {
                this.expireTime = '';
                this.jobKeyword = '';
            }
        },
        title(value) {
            this.maxLetters = 50
            if (value.length > this.maxLetters) {
                this.title = value.substring(0, this.maxLetters)
            }
            const count = (value.match(/[%٪\*×،\.\-\+«»&'\(\)\/]/g) || []).length
            if (count > 4) {
                this.message = 'عنوان آگهی تنها می‌تواند شامل حروف الفبا، اعداد و 4 نوع از علامت‌های % ٪ * × ، . - + « » & \' ( ) / باشد';
                this.iconIndex = 1;
            } else {
                this.clearMessage();
                this.iconIndex = 0;
            }
        },
        description(value) {
            if (value.length >= 10) {
                this.descError = ''
            } else this.descError = 'توضیحات آگهی را پر کنید.'
        },
        jobKeyword: function (value) {
            this.keyWord = value;
            const sillabels = this.keyWord.split(' ').filter(x => x);
            if (sillabels.length < 2) {
                this.productMessage = 'حداقل 2 کلمه باید وارد شود';
            } else if (sillabels.length >= 5) {
                this.productMessage = 'حداکثر 4 کلمه باید وارد شود';
            } else {
                this.productMessage = '';
            }

        },
    },
    mounted() {
        Bus.$on('times', (value) => {
            if (value.key === this.$vnode.key)
                this.adsTimes = value
        });
        this.getTitles();
        this.getTitlesAds();
        Bus.$on('cityInfo', (value) => {
            this.city = value.city;
            if (value.neighborhood !== null) {
                this.neighborhood = value.neighborhood;
            }
        });

        Bus.$on('category-current', (current) => {
            this.category = current;
        });
    }
}
</script>

<style scoped>
.font-20 {
    font-size: 16pt;
}


</style>